export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_swastik-care-1/artifacts/qsjgifae_IMG_0112.jpg";

export const BRAND = {
  name: "Swastik Healthcare",
  whatsapp: "919719606660",
  whatsappMessage: "Hi, I'd like to book a test at Swastik Healthcare.",
  phoneMain: "+91 97196 06660",
  phoneHome: "+91 97196 06660",
};

export const NAV_LINKS = [
  { label: "Packages", href: "#packages" },
  { label: "Specialists", href: "#doctors" },
  { label: "Centres", href: "#locations" },
  { label: "Book Now", href: "#book" },
];

export const TRUST_BADGES = [
  { label: "10+ Years of Trusted Care", icon: "HeartPulse" },
  { label: "NABL-Accredited Laboratory", icon: "ShieldCheck" },
  { label: "Home Sample Collection", icon: "Home" },
  { label: "Reports Within 24 Hours", icon: "Clock" },
  { label: "15,000+ Families Served", icon: "Users" },
  { label: "Doctor-Recommended Care", icon: "Stethoscope" },
];

export const HEALTH_PACKAGES = [
  {
    id: "complete-checkup",
    name: "Swastik Complete Checkup",
    desc: "A full-body scan of your health — 72 parameters covering blood, sugar, kidney, liver, thyroid, lipid and vitals.",
    params: "72 Parameters",
    size: "large",
    tag: "Most Booked",
  },
  {
    id: "diabetes-bp",
    name: "Diabetes & Hypertension Profile",
    desc: "Blood sugar, HbA1c, BP-linked markers tracked in one sitting.",
    params: "18 Parameters",
    size: "small",
  },
  {
    id: "womens-wellness",
    name: "Women's Wellness Profile",
    desc: "Hormonal balance, thyroid, iron and bone health, curated for women at every stage.",
    params: "34 Parameters",
    size: "medium",
  },
  {
    id: "cardiac-risk",
    name: "Cardiac Risk Assessment",
    desc: "Lipid profile, ECG, cardiac markers to read your heart's real story.",
    params: "22 Parameters",
    size: "small",
  },
  {
    id: "thyroid-profile",
    name: "Thyroid Profile",
    desc: "Complete T3, T4, TSH panel for precise thyroid diagnosis.",
    params: "6 Parameters",
    size: "small",
  },
  {
    id: "senior-care",
    name: "Senior Citizen Care Package",
    desc: "A gentle, thorough checkup designed around the needs of ageing bodies.",
    params: "48 Parameters",
    size: "medium",
  },
  {
    id: "fever-infection",
    name: "Fever & Infection Panel",
    desc: "CBC, malaria, dengue, typhoid — answers fast, when you need them most.",
    params: "12 Parameters",
    size: "small",
  },
];

export const MANIFESTO_CHAPTERS = [
  {
    number: "01",
    title: "Our Origin",
    text: "Swastik Healthcare began with a simple frustration — families running between labs, clinics and hospitals just to piece together an answer. We built one address where diagnostics and doctors work as a single team.",
    image:
      "https://images.unsplash.com/photo-1733976586565-76c2707eed9d?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    number: "02",
    title: "Our Standard",
    text: "Every sample that enters our lab is handled under NABL-grade protocol. Every report is reviewed by an MD-qualified pathologist before it reaches your hands. No shortcuts, no guesswork.",
    image:
      "https://images.unsplash.com/photo-1639772823849-6efbd173043c?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    number: "03",
    title: "Our Reach",
    text: "From doorstep sample collection to three neighbourhood centres, we shaped our network around your convenience — not the other way around.",
    image:
      "https://images.unsplash.com/photo-1589554882513-691f8f071f72?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    number: "04",
    title: "Our Promise",
    text: "Accurate results, honest pricing, and a team that treats your report like it belongs to someone they love — because in this line of work, it always does.",
    image:
      "https://images.pexels.com/photos/39192358/pexels-photo-39192358.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const DOCTORS = [
  {
    name: "Dr. Aditya Rawat",
    qualification: "MBBS, MD (Pathology)",
    specialty: "Pathology & Lab Diagnostics",
    image:
      "https://images.unsplash.com/photo-1622253692010-333f2da6031d?crop=entropy&cs=srgb&fm=jpg&q=85",
    bio: "Dr. Rawat brings 12+ years of experience in clinical pathology, leading Swastik's NABL-accredited laboratory with a focus on precision and fast turnaround.",
    highlights: [
      "12+ years in clinical & molecular pathology",
      "Specialist in histopathology and cytopathology",
      "Oversees quality assurance across all Swastik labs",
    ],
  },
  {
    name: "Dr. Neha Kapoor",
    qualification: "MBBS, DMRD (Radiodiagnosis)",
    specialty: "Radiology & Imaging",
    image:
      "https://images.unsplash.com/photo-1644335326474-544fbcf8855f?crop=entropy&cs=srgb&fm=jpg&q=85",
    bio: "Dr. Kapoor specialises in ultrasound, CT and MRI interpretation, known among referring doctors for clear, detailed radiology reports.",
    highlights: [
      "9+ years in diagnostic imaging",
      "Expert in USG, CT & MRI reporting",
      "Fluent patient communication in Hindi & English",
    ],
  },
  {
    name: "Dr. Vikram Sethi",
    qualification: "MBBS, MD (Medicine)",
    specialty: "General Medicine & Cardiac Care",
    image:
      "https://images.unsplash.com/photo-1622253694238-3b22139576c6?crop=entropy&cs=srgb&fm=jpg&q=85",
    bio: "Dr. Sethi leads Swastik's consultation wing, specialising in preventive cardiac care, lifestyle disorders and echo-based diagnostics.",
    highlights: [
      "15+ years senior physician experience",
      "Expert in advanced echocardiography",
      "Focus on diabetes, hypertension & heart health",
    ],
  },
  {
    name: "Dr. Ritu Bhandari",
    qualification: "MBBS, MD (Pathology)",
    specialty: "Pathology & Women's Health Diagnostics",
    image:
      "https://images.unsplash.com/photo-1749700332031-cf99864959ea?crop=entropy&cs=srgb&fm=jpg&q=85",
    bio: "Dr. Bhandari's work centres on women's hormonal and prenatal diagnostics, ensuring every report is explained with warmth and clarity.",
    highlights: [
      "8+ years in pathology & endocrinology panels",
      "Specialised in PCOS & fertility-linked testing",
      "Known for patient-first report counselling",
    ],
  },
];

export const LOCATIONS = [
  {
    name: "Swastik Diagnostic Centre – Sahastradhara Road",
    address:
      "1st Floor, Shop No. 1, SBD Tower, Main Sahastradhara Road, Suman Nagar, Adhoiwala, Dehradun, Uttarakhand – 248001",
    phone: "097196 06660",
    hours: ["Open 24 Hours"],
    mapsQuery:
      "Swastik Diagnostic Centre, SBD Tower, Sahastradhara Road, Dehradun, Uttarakhand 248001",
  },
  {
    name: "Swastik Ultrasound Centre & Orthopaedic Clinic – Prem Nagar",
    address:
      "16/A, Special Wing, Near Police Thana, Prem Nagar, Dehradun, Uttarakhand – 248007",
    phone: "097196 06660",
    hours: ["Monday–Saturday: 8:30 AM – 8:00 PM", "Sunday: Open 24 Hours"],
    mapsQuery:
      "Swastik Ultrasound Centre & Orthopaedic Clinic, 16/A, Special Wing, Near Prem Nagar Thana, Prem Nagar, Dehradun, Uttarakhand 248007",
  },
  {
    name: "Swastik Ultrasound And Imaging Centre – Vikasnagar",
    address:
      "Shop No. 1, Chirayun Health Care, Vikasnagar, Hospital Road, Punjabi Colony, Vikas Nagar – 248198, Uttarakhand",
    phone: "082187 33992",
    hours: ["Open 24 Hours"],
    mapsQuery:
      "Swastik Ultrasound And Imaging Centre, Shop No. 1, Chirayun Health Care, Hospital Road, Punjabi Colony, Vikas Nagar, Uttarakhand 248198",
  },
  {
    name: "Malik Ultrasound Center – Rishikesh",
    address:
      "29, Near Andhra Bank, Dehradun Road, Adarsh Gram, Rishikesh – 249201, Uttarakhand",
    phone: "099889 82311",
    hours: ["Monday–Saturday: 9:00 AM – 6:00 PM", "Sunday: Closed"],
    mapsQuery:
      "Malik Ultrasound Center, 29, Near Andhra Bank, Dehradun Road, Adarsh Gram, Rishikesh, Uttarakhand 249201",
  },
];

export const LOCATIONS_IMAGE =
  "https://images.pexels.com/photos/6809658/pexels-photo-6809658.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const HERO_IMAGE =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_swastik-care-1/artifacts/ux4iqck4_ChatGPT%20Image%20Aug%2015%2C%202026%20at%2010_40_42%20AM.png";

export const HERO_IMAGE_MOBILE =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_swastik-care-1/artifacts/czvljjnx_ChatGPT%20Image%20Aug%2015%2C%202026%20at%2011_32_16%20AM.png";

export const TESTIMONIALS = [
  {
    name: "Priya Malhotra",
    text: "The home collection was so smooth — the technician was on time, professional, and my report came the same evening. Never going back to running between labs.",
  },
  {
    name: "Rakesh Bisht",
    text: "Booked a full body checkup for my parents. Clean centre, polite staff, and the doctor actually took time to explain the report to us. Rare these days.",
  },
  {
    name: "Simran Kaur",
    text: "Got my thyroid profile done here on a colleague's recommendation. Accurate, fast, and the WhatsApp updates kept me informed the whole way.",
  },
  {
    name: "Anmol Sharma",
    text: "Swastik's cardiac package caught an issue my regular checkup missed. Grateful for how thorough and honest the whole process was.",
  },
];

export const SERVICE_TYPES = [
  "Health Checkup",
  "Diagnostic Test",
  "Home Sample Collection",
  "Doctor Consultation",
];
